import { isAnyOf } from '@reduxjs/toolkit';
import { assembleKit, disassembleKit, fetchKit, fetchKitPlan } from './operatorKitsThunks';
import { KIT_STEP, planArgOf } from './operatorKitsUtils';
import { OPERATOR_ERROR } from '../operator/operatorErrors';

const isKitWriteOutcome = isAnyOf(
  assembleKit.fulfilled,
  assembleKit.rejected,
  disassembleKit.fulfilled,
  disassembleKit.rejected
);

const isKitWriteRejection = isAnyOf(assembleKit.rejected, disassembleKit.rejected);

/** A 412 of the kit on screen, or any answer of a write an earlier visit to it sent. */
const leavesKitBehind = (action) =>
  (isKitWriteRejection(action) && action.payload?.kind === OPERATOR_ERROR.STALE && !action.meta.offScreenTask) ||
  (isKitWriteOutcome(action) && Boolean(action.meta.earlierVisit));

/**
 * The station's reactions. When the kit on screen is behind the server — the
 * stock changed under its plan, or a write of an earlier visit landed — the
 * kit is asked again, and its plan where the visit shows one. Off screen
 * nothing is asked: the kit loads when it opens.
 *
 * @param {Function} startListening
 */
export const registerOperatorKitsListeners = (startListening) => {
  startListening({
    predicate: leavesKitBehind,
    effect: (_, { dispatch, getState }) => {
      const visit = getState().operatorKits;
      if (visit.kitId == null) return;
      dispatch(fetchKit(visit.kitId));
      if (visit.step === KIT_STEP.SOURCES || visit.step === KIT_STEP.DESTINATION) {
        dispatch(fetchKitPlan(planArgOf(visit)));
      }
    },
  });
};
